import { IAccount, IApplication } from '../account/account.interface';
import { ControlsOf, IAddress, IContact } from '../common.interface';
import { extract } from '../config.interface';
import { IProviderGroup } from './provider-group.interfaces';

export type IProviderAPI = {
  accountNumber: string;
  address?: IAddress;
  certified?: string;
  claimStatusStatus?: string;
  contact?: IContact;
  degree?: string;
  ecsStatus?: string;
  eligibilityStatus?: string;
  eraStatus?: string;
  feeSchedule?: string;
  firstName?: string;
  groupId?: string;
  id: string;
  lastName?: string;
  mi?: string;
  name?: string;
  notes?: string;
  pms?: string;
  providerGroupId: string;
  statementStatus?: string;
};

export type IProvider = {
  account?: IAccount;
  accountNumber: string;
  addressCity?: string;
  addressLine1?: string;
  addressLine2?: string;
  addressState?: string;
  addressZipcode?: string;
  application?: IApplication;
  billingMethod?: string;
  certified?: string;
  claimRoutingMethod?: string;
  claimStatusDate?: Date;
  claimStatusStatus?: string;
  contactEmail?: string;
  contactFax?: string;
  contactName?: string;
  contactPhone?: string;
  contactTitle?: string;
  dateLastCertified?: Date;
  dateLastClaim?: Date;
  dateLastDbUpdate?: Date;
  dateLastStatement?: Date;
  dateSetup?: Date;
  dateTerminate?: Date;
  degree?: string;
  ecsDate?: Date;
  ecsStatus?: string;
  eligibilityDate?: Date;
  eligibilityStatus?: string;
  eraDate?: Date;
  eraStatus?: string;
  feeSchedule?: string;
  firstName?: string;
  //groupEnrollments?: IGroupEnrollment[];
  id: string;
  lastName?: string;
  lastUpdatedBy?: string;
  mI?: string;
  mailboxId?: string;
  neicId?: string;
  neicSiteId?: string;
  notes?: string;
  nsfBatchNumber?: number;
  organizationName?: string;
  organizationType?: string;
  pMS?: string;
  pMSSoftware?: string;
  pcMemory?: string;
  providerGroup?: IProviderGroup;
  providerGroupId: string;
  recordStatus?: string;
  statementDate?: Date;
  statementMethod?: string;
  statementStatus?: string;
  submitterNumber?: string;
};

export type IProviderDTO = {
  expanded: boolean;
} & IProvider;

export const providerStatusDatesExtractor = extract<IProviderStatusDates>({
  eraStatus: true,
  ecsStatus: true,
  claimStatusStatus: true,
  eligibilityStatus: true,
  statementStatus: true,

  eraDate: true,
  ecsDate: true,
  claimStatusDate: true,
  eligibilityDate: true,
  statementDate: true,
});

export type IQualifier = {
  code: string;
  description: string;
};

export type IBillingIds = {
  billingId?: string;
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  billingIdType: any;
  billingIdTypeCode?: string;
  dateSetup?: Date;
  name?: string;
  providerGroupId?: string;
  providerId?: string;
  rowId?: number;
  status?: string;
};

export type IProviderDetail = {
  description: string;
  groupId: string;
  id: string; //billingId
  index?: number;
  oldId?: string;
  qualifier: string;
  rowId?: number;
  status: string;
};

export type IBatchRemittance = {
  alphaII?: string;
  batch277ca?: string;
  batch277u?: string;
  batchCSV?: string;
  batchHumanReadable?: string;
  batchMachineReadable?: string;
  batchXml?: string;
  combineERA?: string;
  humanReadable271?: string;
  rejectPrintClaims?: string;
  remit277ca?: string;
  remit277u?: string;
  remitCSVDaily?: string;
  remitCsv?: string;
  remitHumanReadable?: string;
  remitMachineReadable?: string;
  remitXml?: string;
};

export const providerBatchRemittanceExtractor = extract<IBatchRemittance>(
  {
    batch277ca: true,
    batch277u: true,
    batchCSV: true,
    batchHumanReadable: true,
    batchMachineReadable: true,
    batchXml: true,
    remit277ca: true,
    remit277u: true,
    remitCSVDaily: true,
    remitHumanReadable: true,
    remitMachineReadable: true,
    remitXml: true,
    remitCsv: true,
    humanReadable271: true,
    rejectPrintClaims: true,
    alphaII: true,
    combineERA: true,
  },
  (source) => {
    if (typeof source == 'boolean') {
      return source;
    }
    return source == 'Y' || source == 'A';
  },
);

export class ProviderFilters {
  id?: string;
  groupId?: string;
  accountNumber?: string;
  groupName?: string;
  feeSchedule?: string;
  pMS?: string;
  contactName?: string;
  phone?: string;
  email?: string;
  zipcode?: string;
  city?: string;
  state?: string;
  accountName?: string;
}

export type ProviderBillingsParams = {
  billingId?: string;
  // billingIdType?: BillingIdTypeFilterInput
  billingIdTypeCode?: string;
  dateLastDbUpdate?: string;
  dateSetup?: string;
  lastUpdatedBy?: string;
  name?: string;
  notes?: string;
  // providerGroup?: ProviderGroupFilterInput,
  providerGroupId?: string;
  providerId?: string;
  rowId?: string;
  status?: string;
};

export type IBillingType = {
  billingId: string;
  billingIdTypeCode: string;
  error?: boolean;
  name?: string;
  notes?: string;
  providerGroupId?: string;
  providerId?: string;
  rowId?: number;
  saved?: boolean;
  status: string;
};

export type IProviderStatusDates = {
  claimStatusDate?: string;
  claimStatusStatus?: string;
  ecsDate?: string;
  ecsStatus?: string;
  eligibilityDate?: string;

  eligibilityStatus?: string;
  eraDate?: string;
  eraStatus?: string;
  statementDate?: string;
  statementStatus?: string;
};

export type ProviderStatusDatesForm = ControlsOf<IProviderStatusDates>;
